// import React from "react";

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="footer-top">
//         <div className="container">
//           <div className="row">
//             {/* Column 1 */}
//             <div className="col-md-3">
//               <div className="mb-3">
//                 <a href="#">
//                   <img src="/images/logo-white.png" alt="Logo White" />
//                 </a>
//               </div>
//               <p className="pb-3">
//                 We make your dream more <br /> beautiful &amp; enjoyful with lots of happiness.
//               </p>
//             </div>

//             {/* Column 2 */}
//             <div className="col-md-3">
//               <h5 className="fw-bold mb-3 pb-2 f-title">The Company</h5>
//               <ul className="f-list">
//                 <li>
//                   <a href="#">Home</a>
//                 </li>
//                 <li>
//                   <a href="#">Features</a>
//                 </li>
//                 <li>
//                   <a href="#">How It Works</a>
//                 </li>
//                 <li>
//                   <a href="#">Contact Us</a>
//                 </li>
//               </ul>
//             </div>

//             {/* Column 3 */}
//             <div className="col-md-3">
//               <h5 className="fw-bold mb-3 pb-2 f-title">Legal Links</h5>
//               <ul className="f-list">
//                 <li>
//                   <a href="#">Terms of services</a>
//                 </li>
//                 <li>
//                   <a href="#">Privacy Policies</a>
//                 </li>
//                 <li>
//                   <a href="#">FAQ’s</a>
//                 </li>
//                 <li>
//                   <a href="#">Support</a>
//                 </li>
//               </ul>
//             </div>

//             {/* Column 4 */}
//             <div className="col-md-3">
//               <h5 className="fw-bold mb-3 pb-2 f-title">Follow Us</h5>
//               <div className="social">
//                 <a href="#">
//                   <i className="bi bi-whatsapp"></i>
//                 </a>
//                 <a href="#" className="ms-3">
//                   <i className="bi bi-facebook"></i>
//                 </a>
//                 <a href="#" className="ms-3">
//                   <i className="bi bi-instagram"></i>
//                 </a>
//                 <a href="#" className="ms-3">
//                   <i className="bi bi-linkedin"></i>
//                 </a>
//                 <a href="#" className="ms-3">
//                   <i className="bi bi-google"></i>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom bar */}
//       <div className="footer-bottom">
//         <div className="container text-center">
//           <p>© 2025 VIAGGIO. Powered by Ferry SaaS</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


const Footer = ({ socialMedia }) => {
  const socialIcons = [
    { key: "whatsapp", icon: "bi-whatsapp", prefix: "https://wa.me/" },
    { key: "facebook", icon: "bi-facebook" },
    { key: "instagram", icon: "bi-instagram" },
    { key: "linkedin", icon: "bi-linkedin" },
    { key: "skype", icon: "bi-skype" },
  ]

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* Column 1 */}
            <div className="col-md-3">
              <div className="mb-3">
                <a href="#" className="d-flex align-items-center gap-2 text-white text-decoration-none fw-bold" style={{ fontSize: "1.4rem" }}>
                  <img src="/images/voyagian-logo.png" alt="Logo" style={{ height: "45px", width: "auto" }} />
                  <span style={{ letterSpacing: "1px", textTransform: "uppercase" }}>Voyagian</span>
                </a>
              </div>
              <p className="pb-3">
                We make your dream more <br /> beautiful &amp; enjoyful with lots of happiness.
              </p>
            </div>

            {/* Column 2 */}
            <div className="col-md-3">
              <h5 className="fw-bold mb-3 pb-2 f-title">The Company</h5>
              <ul className="f-list">
                <li>
                  <a href="#">Home</a>
                </li>
                <li>
                  <a href="#">Features</a>
                </li>
                <li>
                  <a href="#">How It Works</a>
                </li>
                <li>
                  <a href="#">Contact Us</a>
                </li>
              </ul>
            </div>

            {/* Column 3 */}
            <div className="col-md-3">
              <h5 className="fw-bold mb-3 pb-2 f-title">Legal Links</h5>
              <ul className="f-list">
                <li>
                  <a href="#">Terms of services</a>
                </li>
                <li>
                  <a href="#">Privacy Policies</a>
                </li>
                <li>
                  <a href="#">FAQ’s</a>
                </li>
                <li>
                  <a href="#">Support</a>
                </li>
              </ul>
            </div>

            {/* Column 4 */}
            <div className="col-md-3">
              <h5 className="fw-bold mb-3 pb-2 f-title">Follow Us</h5>
              <div className="social">
                {socialIcons.map((item) => {
                  const link = socialMedia?.[item.key]
                  if (!link) return null

                  const href = item.key === "whatsapp" && !link.startsWith("http") ? `${item.prefix}${link}` : link

                  return (
                    <a key={item.key} href={href} target="_blank" rel="noopener noreferrer" className="ms-3 first:ms-0">
                      <i className={`bi ${item.icon}`}></i>
                    </a>
                  )
                })}
                {!socialMedia && <span className="text-muted small">Stay tuned for social updates!</span>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container text-center">
          <p>© 2025 VOYAGIAN. Powered by Ferry SaaS</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
